/* wavify */
function wavify() {
  if ($(window).width() > 767) {
    $('#wave').wavify({
      height: 60,
      bones: 20,
      amplitude: 30,
      color: '#fff',
      speed: .25
    });

    $('#wave2').wavify({
      height: 60,
      bones: 25,
      amplitude: 20,
      color: '#fff',
      speed: .15
    });
  } else {
    $('#wave').wavify({
      height: 40,
      bones: 8,
      amplitude: 20,
      color: '#fff',
      speed: .25
    });

    $('#wave2').wavify({
      height: 40,
      bones: 8,
      amplitude: 20,
      color: '#fff',
      speed: .15
    });
  }
}

$(document).ready(function() {
  // GENERIC
  //----------------------------------//
  $('.select, .country_select, .state_select').select2();

  // GENERAL POPUP
  function toggle_modal() {
    //open popup targeted with data-attr
    $('.popup_trigger').on('click', function(e){
        e.preventDefault();
        
        var windowHeight = $(window).height();

        if ($('.slider_videos').length > 0) {
          var id = $(this).attr('data-youtube-id');
          var autoplay = '?autoplay=1';
          var related_no = '&rel=0';
          var src = '//www.youtube.com/embed/'+id+autoplay+related_no;
          $("#youtube").attr('src', src);

          $(this).parents().find('.slider_videos').siblings('.popup[data-popup="' + $(this).attr('data-popup-target') + '"]').addClass('is-visible');

          var popupHeight = $(this).parents().find('.slider_videos').siblings('.popup[data-popup="' + $(this).attr('data-popup-target') + '"]').find('.popup-container').outerHeight();

          if(popupHeight > windowHeight) {
            $(this).parents().find('.slider_videos').siblings('.popup[data-popup="' + $(this).attr('data-popup-target') + '"]').find('.popup-container').css({'max-height': '80vh', 'overflow-y' : 'scroll'});
          }
        } else {
          let value = $(this).attr('value'),
             popup = $('.popup[data-popup="' + $(this).attr('data-popup-target') + '"]');

          popup.addClass('is-visible');
          popup.find('#linked_to').val(value);

          var popupHeight = $('.popup[data-popup="' + $(this).attr('data-popup-target') + '"]').find('.popup-container').outerHeight();

          if(popupHeight > windowHeight) {
            $('.popup[data-popup="' + $(this).attr('data-popup-target') + '"]').find('.popup-container').css({'max-height': '80vh', 'overflow-y' : 'scroll'});
          }
        }
    });

    function close_modal() {
      $('.popup').removeClass('is-visible');
      if ($('.slider_videos').length > 0) {
        $("#youtube").attr('src', '');
      }
    }

    //close popup
    $('.popup').on('click', function(e){
      if( $(e.target).is('.popup-close') || $(e.target).is('.popup') ) {
        e.preventDefault();
        close_modal();
      }
    });

    //close popup when clicking the esc keyboard button
    $(document).keyup(function(e){
      if(e.which=='27'){
        close_modal();
      }
    });
  }
  toggle_modal();

  $('nav .cart').click(function() {
    var toggleCartHeight = $('nav .toggle_cart').outerHeight();
    var windowHeight = $(window).height();
    var windowHeight2 = windowHeight - 250;

    if(toggleCartHeight > windowHeight2) {
      $('nav .toggle_cart').css({'max-height': '70vh', 'overflow-y' : 'scroll'});
    }
  });

  // HOME
  //----------------------------------//
  wavify();

  if ($('#page_home').length > 0) {
    $(".slider_collection").slick({
      lazyLoad: "progressive",
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 800,
      pauseOnHover: true,
      infinite: true,
      arrows: true,
      appendArrows: $('.slider_nav_col'),
      dots: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            swipeToSlide: true,
            speed: 150
          }
        },
        {
          breakpoint: 767,
          settings: {
            centerMode: true,
            centerPadding: '100px',
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 2,
            swipeToSlide: true,
            speed: 150
          }
        },
        {
          breakpoint: 480,
          settings: {
            centerMode: true,
            centerPadding: '80px',
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            speed: 150
          }
        }
      ]
    });
  }

  // BOUTIQUE
  /* slider */
  if ($('#page_boutique').length > 0) {
    if ($(".slider_straps").length > 0) {
      if ($(window).width() > 900) {
        $(".slider_straps").slick({
          lazyLoad: "progressive",
          autoplay: true,
          autoplaySpeed: 5000,
          speed: 800,
          pauseOnHover: true,
          infinite: true,
          arrows: true,
          appendArrows: $('.slider_nav'),
          dots: true,
          slidesToShow: 4,
          slidesToScroll: 4,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                centerMode: false,
                arrows: false,
                slidesToShow: 2,
                slidesToScroll: 2,
                swipeToSlide: true,
                speed: 150
              }
            }
          ]
        });
      } else {
        // $(".slider_straps").slick('unslick');
      }
    }
  }

  // PACKS

  if ($('#page_boutique').length > 0) {
    if ($(".slider_packs").length > 0) {
      if ($(window).width() > 900) {
        $(".slider_packs").slick({
          lazyLoad: "progressive",
          autoplay: true,
          autoplaySpeed: 5000,
          speed: 800,
          pauseOnHover: true,
          infinite: true,
          arrows: true,
          appendArrows: $('.nav_pack'),
          dots: true,
          slidesToShow: 4,
          slidesToScroll: 4,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                centerMode: false,
                arrows: false,
                slidesToShow: 2,
                slidesToScroll: 2,
                swipeToSlide: true,
                speed: 150
              }
            }
          ]
        });
      } else {
        // $(".slider_packs").slick('unslick');
      }
    }
  }

  // PRODUCT DETAILS
  if ($('#product_details').length > 0 || $('#page_boutique').length > 0) {
    let $sliderStrap = $(".slider_strap"),
        $popupStrap = $(".popup_straps");

    if ($sliderStrap.length > 0) {
      $sliderStrap.slick({
        lazyLoad: "progressive",
        autoplaySpeed: 5000,
        speed: 800,
        pauseOnHover: true,
        infinite: true,
        arrows: true,
        appendArrows: $('#slider_strap.slider_nav'),
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '0px',
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              centerMode: false,
              arrows: true,
              slidesToShow: 2,
              slidesToScroll: 1,
              swipeToSlide: true,
              speed: 150
            }
          }
        ]
      });

      $sliderStrap.on('afterChange', function(event, slick, currentSlide, nextSlide){
        let composed_price = $(slick.$slides.get(currentSlide)).data('composed_price'),
          price = $(slick.$slides.get(currentSlide)).data('price'),
          product_id = $(slick.$slides.get(currentSlide)).data('product_id');

        $popupStrap.find('.price-tagline > .regular-price').html(price + vars.currency_symbol);
        $popupStrap.find('.price-tagline > .composed-price').html(composed_price + vars.currency_symbol);
        $popupStrap.find('input#product_id').val(product_id);
      });
    }

    if ($('#product_details').length > 0) {
      // REVIEWS
      $( ".slider_comments" ).each(function() {
        $(this).slick({
          lazyLoad: "progressive",
          autoplay: false,
          speed: 800,
          infinite: false,
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1
        });
      });
    }
  }

  // METHODE & REVIEWS
  /* slider */
  if ($('#page_method').length > 0 || $('#page_reviews').length > 0) {
    $(".slider_testimonials").slick({
      lazyLoad: "progressive",
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 800,
      pauseOnHover: true,
      infinite: true,
      arrows: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }

  // METHODE & THANKS
  /* slider */
  if ($('#page_method').length > 0 || $('#thanks_page').length > 0 || $('#shops_page').length > 0) {
    $(".slider_videos").slick({
      lazyLoad: "progressive",
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 800,
      pauseOnHover: true,
      infinite: true,
      arrows: true,
      dots: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      appendArrows: $('.slider_nav'),
      responsive: [
        {
          breakpoint: 900,
          settings: {
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 2,
            swipeToSlide: true,
            speed: 150
          }
        }
      ]
    });
  }

  // CART - PAYMENT
  /* highlight payment method on click */
  $('#checkout_page .highlight').click(function() {
    $('#checkout_page .highlight').removeClass('active');
    $(this).addClass('active');
  });

  // THANKS PAGE 
  if ($('#thanks_page').length > 0) {
    $('body').addClass('thanks_page');
  }

  //ACCOUNT
  /* open order details */
  $('.box_orders .order_resume').click(function() {
    $(this).parent().toggleClass('active');
  });

  // REVIEWS 
  /* slider */
  if ($('#page_reviews').length > 0) {
    $( ".slider_reviews" ).each(function() {
      $(this).slick({
        lazyLoad: "progressive",
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 800,
        pauseOnHover: true,
        infinite: true,
        arrows: false,
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              speed: 150
            }
          }
        ]
      });
    });
  }

  // FAQ
  if ($('#contact_page').length > 0) {
    $('.faq_item').on('click', function(e){
        e.preventDefault();
        $('.faq_item').removeClass('active');
        $('.faq_content').removeClass('active');
        $(this).addClass('active');
        $(this).parent().parent().siblings('.faq_content[data-faq="' + $(this).attr('data-faq-target') + '"]').addClass('active');
    });

    $('.faq_question .question').on('click', function(e){
        e.preventDefault();
        $('.faq_question').removeClass('active');
        $(this).parent().toggleClass('active');
    });
  }

  // CGV
  if ($('#cgv_page').length > 0) {
    if ($(window).width() > 900) {
      $('.tabs_nav > div').click(function(e) {
        e.preventDefault();

        $('.tabs_nav > div').removeClass('active');
        $('.tabs_content .chapter').removeClass('active');
        $(this).addClass('active');
        $(this).parent().parent().next().find('.chapter[data-content="' + $(this).attr('data-target') + '"]').addClass('active');
      });
    }
  }

  // FOOTER - MOBILE
  //----------------------------------//
  if ($(window).width() < 901) {
    $('.footer_title').click(function() {
     $(this).siblings('div').toggleClass('active');
    });
  }

  $(document).bind( "mouseup touchend", function(e){
    // INPUT NUMBER
    var dropdownAge = $(".dropdown_age");
    if (!dropdownAge.is(e.target) && dropdownAge.has(e.target).length === 0) {
      dropdownAge.removeClass('open');
      $('.select_age').removeClass('open');
    }
  });

  // steppers elements height
  var maxHeight = 0;
  $("#cart_stepper .box_wrapper > div").each(function(){
    if ($(this).height() > maxHeight) { 
      maxHeight = $(this).height();
    }
  });
  $("#cart_stepper .box_wrapper > div").css('min-height', maxHeight);

  var stepperMaxHeight = 0;
  $("#stepper .box_wrapper > div").each(function(){
    if ($(this).height() > stepperMaxHeight) { 
      stepperMaxHeight = $(this).height(); 
    }
  });
  $("#stepper .box_wrapper > div").css('min-height', stepperMaxHeight);

});

$(window).resize(function() {
  wavify();
});




